(function($) {

  var $qtyBtnTrigger = $('.js-enable-qty-trigger, .js-btn-qty button');
  var $buttonPay = $('.js-button-animation-ctrl');
  
  $qtyBtnTrigger.click(function(e){
    e.preventDefault();
    $buttonPay.addClass('c-button--pulse');
    setTimeout(function() { 
      $buttonPay.removeClass('c-button--pulse');
    }, 500);
  });

})(jQuery);